<script lang="ts">
	/**
	 * «نسخة جديدة جاهزة» — the non-modal update notice SPEC §1.3 calls for.
	 *
	 * Only for an update found while the app is in use (one found as the app
	 * opens is applied straight away — `$lib/pwa/register.ts`): an update
	 * reloads the page, which would stop a recitation. The person taps «تحديث»
	 * when it suits them, or closes the notice; either way the new version also
	 * starts the next time the app is opened.
	 *
	 * Rendered once, in the root layout. It eases down into place as it appears
	 * (`@starting-style`) and carries `view-transition-name: update-toast`, so
	 * a route change animates the page beneath it while the notice stays put.
	 */
	import { onMount } from 'svelte';

	import { applyUpdate, onUpdateReady } from '$lib/pwa/register';
	import Icon from '$lib/ui/icons/Icon.svelte';

	let ready = $state(false);
	let hidden = $state(false);

	onMount(() => onUpdateReady((next) => (ready = next)));
</script>

{#if ready && !hidden}
	<div class="toast" role="status">
		<Icon name="reset" size={1.1} />
		<span class="text">نسخة جديدة من التطبيق جاهزة</span>
		<button type="button" class="go press" onclick={applyUpdate}>تحديث</button>
		<button type="button" class="close press" aria-label="إغلاق" onclick={() => (hidden = true)}
			>×</button
		>
	</div>
{/if}

<style>
	.toast {
		position: fixed;
		inset-block-start: calc(env(safe-area-inset-top) + var(--space-2));
		inset-inline: var(--space-3);
		z-index: 30;
		display: flex;
		align-items: center;
		gap: var(--space-2);
		max-inline-size: 28rem;
		margin-inline: auto;
		padding-block: var(--space-2);
		padding-inline: var(--space-3) var(--space-2);
		border-radius: var(--radius-pill);
		background-color: var(--hero-bg);
		color: var(--hero-fg);
		box-shadow: var(--shadow-1);
		font-size: var(--step--1);
		view-transition-name: update-toast;
		transition:
			opacity 200ms var(--ease-enter),
			translate 200ms var(--ease-enter);
	}

	@starting-style {
		.toast {
			opacity: 0;
			translate: 0 -0.5rem;
		}
	}

	.text {
		flex: 1;
	}

	button {
		min-block-size: 2.75rem;
		min-inline-size: 2.75rem;
		border: 0;
		border-radius: var(--radius-pill);
		font: inherit;
		cursor: pointer;
	}

	.go {
		padding-inline: var(--space-3);
		background-color: var(--hero-fg);
		color: var(--hero-bg);
		font-weight: 500;
	}

	.close {
		background: none;
		color: inherit;
		font-size: var(--step-1);
		line-height: 1;
	}

	button:focus-visible {
		outline: var(--focus-ring-width) solid var(--hero-fg);
		outline-offset: 2px;
	}
</style>
